<script setup lang="ts">
import { onMounted } from 'vue';

import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { UnavailabilityReason, ItinerarySegmentType } from '../../../models';
import UnavailableProductLayout from '../UnavailableProductLayout.vue';
import UnavailableProductAction from '../UnavailableProductAction.vue';

interface UnavailableAccommodationProductProps {
  reasons: UnavailabilityReason[];
  message: string;
  ingredientIndex: number;
}
const props = defineProps<UnavailableAccommodationProductProps>();

interface UnavailableAccommodationProductEmits {
  (event: 'try-another-date'): void;
  (event: 'explore-other-products'): void;
  (event: 'edit-filters'): void;
}
const emit = defineEmits<UnavailableAccommodationProductEmits>();

const statsigEventsStore = useStatsigEventsStore();

onMounted(() => {
  statsigEventsStore.logTripOverviewUnavailableProductRendered({
    productType: 'accommodation',
    isSelectedProduct: props.reasons.includes(
      UnavailabilityReason.SelectedProduct
    )
      ? 'true'
      : 'false',
    hasSelectedFilters: props.reasons.includes(
      UnavailabilityReason.SelectedFilters
    )
      ? 'true'
      : 'false',
  });
});
</script>

<template>
  <UnavailableProductLayout>
    <template #message>
      {{ props.message }}
    </template>
    <template
      v-if="!props.reasons.includes(UnavailabilityReason.SelectedFilters)"
      #actions
    >
      <template v-for="(reason, index) in props.reasons" :key="index">
        <span v-if="index > 0">&nbsp;{{ $t('planner.or') }}&nbsp;</span>
        <UnavailableProductAction
          :product-action="{
            reason,
            segmentType: ItinerarySegmentType.Accommodation,
            ingredientIndex: ingredientIndex,
          }"
          @explore-other-products="emit('explore-other-products')"
          @edit-filters="emit('edit-filters')"
          @try-another-date="emit('try-another-date')"
        />
      </template>
    </template>
  </UnavailableProductLayout>
</template>
